var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 497.246,
    height: 497.291,
    viewBox: "0 0 497.246 497.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1081 767.291)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 22.098,
    height: 9.917,
    transform: "translate(1328.303 -745.196) rotate(-89.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 22.099,
    height: 9.918,
    transform: "translate(1320.671 -270.159) rotate(-89.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 22.098,
    height: 9.917,
    transform: "matrix(0.897, -0.441, 0.441, 0.897, 1104.318, -413.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 22.096,
    height: 9.917,
    transform: "translate(1530.721 -622.981) rotate(-26.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 22.097,
    height: 9.917,
    transform: "translate(1096.454 -432.291) rotate(-21.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 22.095,
    height: 9.916,
    transform: "translate(1538.598 -606.143) rotate(-21.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 22.098,
    height: 9.918,
    transform: "translate(1090.557 -450.285) rotate(-17.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 22.095,
    height: 9.917,
    transform: "translate(1544.652 -589.984) rotate(-17.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 22.099,
    height: 9.918,
    transform: "translate(1086.048 -468.682) rotate(-12.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 22.097,
    height: 9.917,
    transform: "translate(1549.456 -573.409) rotate(-12.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 22.099,
    height: 9.916,
    transform: "translate(1082.952 -487.364) rotate(-8.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 22.097,
    height: 9.915,
    transform: "translate(1552.987 -556.52) rotate(-8.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 22.099,
    height: 9.916,
    transform: "translate(1081.286 -506.225) rotate(-4.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 22.096,
    height: 9.916,
    transform: "translate(1555.223 -539.412) rotate(-4.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 9.917,
    height: 22.097,
    transform: "translate(1081 -515.246) rotate(-89.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 9.916,
    height: 22.096,
    transform: "translate(1556.087 -512.266) rotate(-89.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 9.916,
    height: 22.098,
    transform: "translate(1081.461 -534.18) rotate(-85.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 9.917,
    height: 22.096,
    transform: "translate(1554.945 -495.047) rotate(-85.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 9.916,
    height: 22.098,
    transform: "matrix(0.158, -0.987, 0.987, 0.158, 1083.363, -553.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 9.916,
    height: 22.096,
    transform: "matrix(0.158, -0.987, 0.987, 0.158, 1552.494, -477.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 9.917,
    height: 22.097,
    transform: "matrix(0.233, -0.973, 0.973, 0.233, 1086.695, -571.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 9.917,
    height: 22.095,
    transform: "translate(1548.753 -461.121) rotate(-76.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 9.916,
    height: 22.098,
    transform: "translate(1091.435 -590.002) rotate(-72.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 9.916,
    height: 22.098,
    transform: "translate(1543.737 -444.613) rotate(-72.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 9.916,
    height: 22.098,
    transform: "matrix(0.378, -0.926, 0.926, 0.378, 1097.557, -607.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 9.918,
    height: 22.096,
    transform: "translate(1537.483 -428.53) rotate(-67.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 9.917,
    height: 22.098,
    transform: "translate(1105.023 -625.322) rotate(-63.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 9.917,
    height: 22.097,
    transform: "matrix(0.447, -0.895, 0.895, 0.447, 1530.022, -412.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 9.918,
    height: 22.097,
    transform: "matrix(0.514, -0.858, 0.858, 0.514, 1113.796, -642.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 9.919,
    height: 22.097,
    transform: "translate(1521.397 -398.025) rotate(-59.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 9.917,
    height: 22.098,
    transform: "translate(1123.818 -658.18) rotate(-54.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 9.917,
    height: 22.097,
    transform: "translate(1511.661 -383.778) rotate(-54.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 9.916,
    height: 22.099,
    transform: "translate(1135.036 -673.438) rotate(-50.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 9.917,
    height: 22.097,
    transform: "translate(1500.868 -370.316) rotate(-50.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 9.917,
    height: 22.097,
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 1147.382, -687.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 9.916,
    height: 22.097,
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 1489.084, -357.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 9.918,
    height: 22.098,
    transform: "translate(1160.783 -701.178) rotate(-41.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 9.917,
    height: 22.096,
    transform: "matrix(0.748, -0.664, 0.664, 0.748, 1476.372, -346.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 9.916,
    height: 22.099,
    transform: "matrix(0.796, -0.605, 0.605, 0.796, 1175.165, -713.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 9.917,
    height: 22.097,
    transform: "translate(1462.81 -335.374) rotate(-37.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 9.918,
    height: 22.097,
    transform: "matrix(0.84, -0.543, 0.543, 0.84, 1190.442, -724.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 9.918,
    height: 22.098,
    transform: "translate(1448.474 -325.768) rotate(-32.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 9.916,
    height: 22.097,
    transform: "matrix(0.879, -0.478, 0.478, 0.879, 1206.53, -734.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 9.916,
    height: 22.097,
    transform: "translate(1433.45 -317.281) rotate(-28.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 9.917,
    height: 22.097,
    transform: "matrix(0.912, -0.409, 0.409, 0.912, 1223.329, -743.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 9.916,
    height: 22.096,
    transform: "translate(1417.823 -309.964) rotate(-24.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 9.917,
    height: 22.097,
    transform: "matrix(0.941, -0.339, 0.339, 0.941, 1240.747, -750.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 9.917,
    height: 22.096,
    transform: "matrix(0.941, -0.339, 0.339, 0.941, 1401.684, -303.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 9.917,
    height: 22.097,
    transform: "matrix(0.964, -0.266, 0.266, 0.964, 1258.675, -756.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 9.916,
    height: 22.095,
    transform: "translate(1385.13 -298.994) rotate(-15.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 9.918,
    height: 22.097,
    transform: "translate(1277.019 -761.662) rotate(-11.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 9.917,
    height: 22.096,
    transform: "translate(1368.252 -295.408) rotate(-11.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 9.917,
    height: 22.096,
    transform: "translate(1294.126 -764.743) rotate(-7.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 9.916,
    height: 22.095,
    transform: "translate(1352.561 -293.254) rotate(-7.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 9.918,
    height: 22.096,
    transform: "matrix(0.998, -0.056, 0.056, 0.998, 1310.722, -766.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 9.918,
    height: 22.095,
    transform: "matrix(0.998, -0.056, 0.056, 0.998, 1337.379, -292.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 22.098,
    height: 9.917,
    transform: "translate(1303.901 -271.332) rotate(-85.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 22.098,
    height: 9.916,
    transform: "translate(1343.615 -744.766) rotate(-85.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 22.098,
    height: 9.917,
    transform: "translate(1283.157 -274.378) rotate(-80.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 22.097,
    height: 9.914,
    transform: "translate(1362.615 -742.784) rotate(-80.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 22.097,
    height: 9.917,
    transform: "matrix(0.252, -0.968, 0.968, 0.252, 1262.118, -279.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 22.097,
    height: 9.917,
    transform: "translate(1381.955 -739.071) rotate(-75.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 22.098,
    height: 9.917,
    transform: "translate(1239.943 -286.733) rotate(-69.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 22.097,
    height: 9.915,
    transform: "translate(1402.426 -733.182) rotate(-70.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 22.098,
    height: 9.916,
    transform: "translate(1219.953 -295.491) rotate(-64.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 22.096,
    height: 9.915,
    transform: "translate(1420.96 -725.971) rotate(-64.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 22.098,
    height: 9.916,
    transform: "matrix(0.498, -0.867, 0.867, 0.498, 1201.582, -305.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 22.096,
    height: 9.915,
    transform: "translate(1438.065 -717.557) rotate(-60.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 22.099,
    height: 9.918,
    transform: "translate(1184.116 -317.016) rotate(-55.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 22.098,
    height: 9.915,
    transform: "matrix(0.569, -0.822, 0.822, 0.569, 1454.401, -707.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 22.098,
    height: 9.918,
    transform: "translate(1167.684 -329.961) rotate(-50.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 22.098,
    height: 9.917,
    transform: "matrix(0.636, -0.772, 0.772, 0.636, 1469.856, -696.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 22.099,
    height: 9.917,
    transform: "translate(1152.394 -344.243) rotate(-45.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 22.096,
    height: 9.917,
    transform: "translate(1484.317 -684.162) rotate(-45.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 22.098,
    height: 9.916,
    transform: "translate(1138.362 -359.761) rotate(-40.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 22.097,
    height: 9.915,
    transform: "translate(1497.683 -670.573) rotate(-40.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 22.099,
    height: 9.916,
    transform: "translate(1125.682 -376.4) rotate(-36.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 22.096,
    height: 9.917,
    transform: "matrix(0.808, -0.589, 0.589, 0.808, 1509.861, -655.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 22.098,
    height: 9.918,
    transform: "matrix(0.855, -0.518, 0.518, 0.855, 1114.447, -394.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 22.099,
    height: 9.916,
    transform: "matrix(0.855, -0.518, 0.518, 0.855, 1520.76, -640.269)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDotted);
export default __webpack_public_path__ + "static/media/circle-dotted.7df2434c982fe096d9d5ae90ca632409.svg";
export { ForwardRef as ReactComponent };